
import { Bank } from "@/models/base";
import { printHumanFloat, printLocalDate } from "@/utils/pretty-print";
import Vue from "vue";

export default Vue.extend({
	props: {
		history: {
			type: Object as ()=>Bank,
			required: true
		}
	},
	computed: {
		timeCreated():string {
			return printLocalDate(this.history.TimeCreated);
		},
		total():string{
			return printHumanFloat(this.history.TotalDC);
		}
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
